import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/stripe': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M640 261.6C640 216.1 618 180.2 575.8 180.2S507.9 216.1 507.9 261.3C507.9 314.8 538.2 339.5 581.4 339.5 602.6 339.5 618.5 334.7 630.6 328V294.6C618.5 300.7 604.6 304.4 587 304.4 569.7 304.4 554.5 298.3 552.5 277.5H639.4C639.6 275.2 640 265.9 640 261.6M552.1 244.8C552.1 224.8 564.4 216.4 575.5 216.4 586.4 216.4 598 224.8 598 244.8H552.1zM439.2 180.2C421.8 180.2 410.6 188.4 404.4 194.1L402.1 183.1H363V387.9L407.4 378.5 407.5 328.3C413.9 333 423.4 339.5 438.9 339.5 470.7 339.5 499.7 316.3 499.7 259.9 499.8 208.3 470.4 180.2 439.2 180.2M428.6 302.7C418.2 302.7 412 298.9 407.7 294.3L407.4 228.3C412 223.2 418.4 219.5 428.6 219.5 444.8 219.5 456 237.7 456 260.9 456.1 284.8 445.1 302.7 428.6 302.7M346.4 124V160.2L301.8 169.7V133.5L346.4 124M301.9 183.2H346.5V336.4H301.9V183.2zM254.1 196.3C264.5 177.2 285.2 181.1 291.2 183.2V224C285.5 222.2 267.8 219.5 257.3 233.3V336.4H213V183.2H251.4L254.1 196.3M165.1 183.2H198.8V221H165.1V284.2C165.1 310.4 193.1 302.2 198.8 299.9V333.7C192.9 336.9 182.2 339.6 167.6 339.6 141.3 339.6 121.5 322.6 121.5 296.3L121.7 153.9 165 144.7 165.1 183.2zM44.9 228.3C44.9 248.3 112.8 238.8 112.8 291.7 112.8 323.7 87.4 339.5 50.5 339.5 35.2 339.5 18.5 336.5 2 329.4V289.4C16.9 297.5 35.9 303.6 50.6 303.6 60.5 303.6 67.6 300.9 67.6 292.7 67.6 271.5 0.1 279.5 0.1 230.3 0.1 198.9 24.1 180.1 60.1 180.1 74.8 180.1 89.5 182.4 104.2 188.2V230C90.7 222.7 73.5 218.6 60 218.6 50.7 218.7 44.9 221.4 44.9 228.3'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/stripe.js
// module id = 2lFo
// module chunks = 144